import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, Grid, Alert, CircularProgress } from '@mui/material';
import { api } from '../../api/api';

// 점포 초대로 가입 (가입 방법 B, 12.01-D011) — 공개 페이지
function JoinStore() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({ username: '', password: '', phone: '', address1: '', town: '', state: '', zipcode: '', storePhone: '' });

  useEffect(() => {
    api.get(`/join/verify/${token}`)
      .then(({ data }) => {
        setInfo(data);
        setF((x) => ({ ...x, username: data.store.ownerName || '', phone: data.store.ownerPhone || '', address1: data.store.address1, town: data.store.town, state: data.store.state, zipcode: data.store.zipcode, storePhone: data.store.storePhone }));
      })
      .catch((e) => setError(e.response?.data?.message || '링크를 확인할 수 없습니다'));
  }, [token]);

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async () => {
    setBusy(true);
    setError('');
    try {
      const { data } = await api.post(`/join/submit/${token}`, f);
      setDone(data);
    } catch (e) { setError(e.response?.data?.message || '저장하지 못했습니다'); }
    setBusy(false);
  };

  const field = (k, label, sm = 6, extra = {}) => (
    <Grid item xs={12} sm={sm}><TextField fullWidth size="small" label={label} value={f[k]} onChange={set(k)} {...extra} /></Grid>
  );

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f6fb', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', p: 2, pt: { xs: 3, sm: 8 } }}>
      <Paper sx={{ p: { xs: 2, sm: 4 }, maxWidth: 560, width: '100%', borderRadius: 3 }}>
        <Typography sx={{ fontSize: 22, fontWeight: 800, color: '#551FFF', mb: 1 }}>Digntec 매장 등록</Typography>
        {!info && !error && <CircularProgress size={24} />}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {done && (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>{done.message}</Alert>
            <Button variant="contained" component={Link} to="/login" sx={{ bgcolor: '#551FFF' }}>로그인</Button>
          </>
        )}
        {info && !done && (
          <>
            <Typography sx={{ mb: 2 }}>
              <b>{info.storeName}</b> 의 {info.as === 'manager' ? '매니저' : '점주'}로 등록합니다. 계정 이메일: <b>{info.email}</b>
            </Typography>
            {info.hasAccount ? (
              <Alert severity="info" sx={{ mb: 2 }}>이미 계정이 있습니다. 아래 매장 정보만 확인하면 기존 계정에 매장이 연결됩니다 (비밀번호는 바뀌지 않습니다).</Alert>
            ) : null}
            <Grid container spacing={1.5}>
              {!info.hasAccount && field('username', '이름 *')}
              {!info.hasAccount && field('password', '비밀번호 * (8자 이상)', 6, { type: 'password' })}
              {field('phone', '휴대폰')}
              {field('storePhone', '매장 전화')}
              {info.as !== 'manager' && field('address1', '매장 주소', 12)}
              {info.as !== 'manager' && field('town', '도시', 5)}
              {info.as !== 'manager' && field('state', '주', 3)}
              {info.as !== 'manager' && field('zipcode', 'ZIP', 4)}
            </Grid>
            <Button fullWidth variant="contained" sx={{ mt: 3, bgcolor: '#551FFF', py: 1.2 }} disabled={busy} onClick={submit}>
              {info.hasAccount ? '매장 연결' : '계정 만들고 매장 연결'}
            </Button>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
              다음 단계: Digntec 이 대표 서명이 들어간 계약서와 설치비 안내를 메일로 보냅니다. 문의 support@digntec.com · (201) 357-7222
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
}

export default JoinStore;
